import StickElementToBottom from './StickElementToBottom.js';
import smoothScroll from './smoothScroll.js';
import USA from './usa-helpers.js';

// set jQuery globally
window.$ = window.jQuery;

const mainElement = document.querySelector('main');
const isInstructionsPage = /^instructions-page/.test(mainElement.className);
const isLevelPage = /^level-page/.test(mainElement.className);

if (isInstructionsPage) {

  const inscription_wrapper_fixed =
    document.querySelector('.inscription-wrapper--fixed');
  const inscription_wrapper_mobile =
    document.querySelector('.inscription-wrapper--mobile');
  const inscription_end_button_wrap =
    document.querySelector('.instructions-end__button-wrap');

  // Focus to input when clicking on wrapper
  document.querySelector('.inscription__input-wrap')
    .addEventListener('click', function() {

      this.querySelector('.inscription__input').focus();
    });

  // Submit form when clicking on cta button
  const inscription_form = document.querySelector('.inscription__form');
  inscription_form.querySelector('.inscription__button')
    .addEventListener('click', () => {
      $(inscription_form).trigger('submit');
    });

  var emailSubmitted = false;

  if (localStorageIsUsable) {

    const validateEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    $(inscription_form).submit(function() {

      const input_wrapper = this.querySelector('.inscription__input-wrap');
      const email = this.querySelector('.inscription__input').value;

      if (validateEmail.test(email)) {
        localStorage.peakEmail = email;
        input_wrapper.style.borderColor = "";
      } else {
        input_wrapper.style.borderColor = "";
        setTimeout(() => input_wrapper.style.borderColor = "#ea3516", 100);
        return false;
      }
    });
    emailSubmitted =
      localStorage.peakEmail && validateEmail.test(localStorage.peakEmail);

    if (emailSubmitted) {
      inscription_end_button_wrap.style.display = "block";
      document.querySelector('.inscription').style.display = "none";

      $('.js-to-level-page').each(function() {
        var jQel = $(this).css('display', 'inline-block');
        if (jQel.is('.o-cta')) {
          jQel.attr('href',
            `/${TRANSLATE.language}/${TRANSLATE.text.pages.level}/`
          );
        }
      });
    }
  }

  // Stick inscription block to the bottom of the window on desktop
  new StickElementToBottom({
    fixedParent: inscription_wrapper_fixed,
    staticParent: document.querySelector('.inscription-wrapper--static'),
    mobileParent: inscription_wrapper_mobile,
    scrollingElement: window,
    afterSwitchToMobile: () => {
      inscription_end_button_wrap.style.display = "block";
      document.querySelector('.below-the-fold__helper').style.height = '';
    },
    afterSwitchToDesktop: () => {
      if (!emailSubmitted) {
        inscription_end_button_wrap.style.display = "none";
      }
      document.querySelector('.below-the-fold__helper').style.height = '100px';
    }
  });

  // Scroll to inscription on mobile
  inscription_end_button_wrap.querySelector('.instructions-end__button')
    .addEventListener('click', () => {

      if (!emailSubmitted) {
        const winHeight = window.innerHeight
          || document.documentElement.clientHeight
          || document.body.clientHeight;
        const inscriptionHeight =
          document.querySelector('.inscription').offsetHeight;
        const scrollOffset =
          Math.floor((winHeight - inscriptionHeight) / 2) * -1;

        const scrollPos = $(inscription_wrapper_mobile).offset().top;
        $('html, body').stop().animate({
          scrollTop: scrollPos + scrollOffset
        }, 300);
      }
    });

  // Fix the inscription block overflow on Windows
  // (when the scrollbar is always visible)
  const setInscriptionMaxWidth = () => {
    const maxWidth =
      `${document.querySelector('.peak-site-header').offsetWidth}px`;
    inscription_wrapper_fixed.style.maxWidth = maxWidth;
    document.querySelector('.below-the-fold').style.maxWidth = maxWidth;
  };
  setInscriptionMaxWidth();

  window.addEventListener('resize', setInscriptionMaxWidth);

  // Show error message if localStorage is not supported or not usable
  if (!localStorageIsUsable) {
    const isPrivateWindow = !localStorageIsUsable && window.localStorage;
    const alertBox = document.querySelector('.alert-box');
    var errorMsg = TRANSLATE.text.level.headline.localestorage_error;
    alertBox.querySelector('.alert-box__title').innerHTML = errorMsg.title;
    alertBox.querySelector('.alert-box__copy').innerHTML =
      errorMsg[isPrivateWindow ? 'noprivate' : 'details'];
    alertBox.style.display = 'block';

    alertBox.addEventListener('click', e => {
      if (e.target === alertBox) {
        alertBox.style.display = 'none';
      }
    });
  }
}

if (isLevelPage) {
  ELEVATION.pageload();

  if (!localStorageIsUsable) {
    ELEVATION.updateHeadline(null);
  }

  $('.peak-site-footer__update-icon-wrap').click(function() {
    $(this).toggleClass('peak-site-footer__update-icon-wrap--rotated');
    ELEVATION.updateLastUpdateTimestamp();
  });
}

// Get billing country
if (!localStorageIsUsable || !window.localStorage.countryName) {

  $.get('https://freegeoip.net/json/', response => {
    const countryInput = document.querySelector('.inscription__country');
    const countryName = response.country_name;
    const countryCode = response.country_code.toLowerCase();

    if (countryInput) {
      countryInput.value = response.country_name;
    }
    if (localStorageIsUsable) {
      window.localStorage.countryName = countryName;
      window.localStorage.countryCode = countryCode;

      if (!USA.isUSA()) {
        return;
      }
      if (isInstructionsPage) {
        USA.convertMetersInHomepage();
      }
      if (isLevelPage) {
        ELEVATION.resetScale();
      }
    }
  }, 'json');
}

// Convert goal from meters to feet if needed
if (isInstructionsPage && USA.isUSA()) {
  USA.convertMetersInHomepage();
}

// Unwrap on-running.com header
document.querySelector('.header-right__link')
  .addEventListener('click', () => {
    document.body.classList.add('onrunning-header--open');
  });

// Wrap on-running.com header
document.querySelector('.onrunning-header__quit')
  .addEventListener('click', () => {
    document.body.classList.remove('onrunning-header--open');
  });

// Call on-running.com header's methods
window.addEventListener('load', () => {
  if (window.mainAppUiElementsCreated) {
    return;
  }
  const On = window.On;
  if (On.SiteHeaderNavDropdown) { new On.SiteHeaderNavDropdown(); }
  if (On.SiteHeaderShopDropdown) { new On.SiteHeaderShopDropdown(); }
  if (On.SiteHeaderSticky) { new On.SiteHeaderSticky(); }
  if (On.FooterNewsletterSignup) { new On.FooterNewsletterSignup(); }
  if (On.NewsletterSubscribeOverlay) { new On.NewsletterSubscribeOverlay(); }
  if (On.FooterNav) { new On.FooterNav(); }
  if (On.SelectPlaceholder) { new On.SelectPlaceholder(); }

  window.mainAppUiElementsCreated = true;
});

// For demo purposes
document.addEventListener('keypress', e => {
  if (!e.ctrlKey || !e.shiftKey) {
    return;
  }
  if (/r/i.test(e.key)) {
    delete window.localStorage.peakReached;
    delete window.localStorage.lastStoredAltitude;
    delete window.localStorage.accumulatedAltitude;
    window.location.reload(true);
  }
  if (/p/i.test(e.key)) {
    ELEVATION.animateScale(0, 1000, 3000);
  }
});



// WEBPACK FOOTER //
// ./src/assets/javascripts/pageload.js